import { packNetAxios } from "@/lib/api-client";
import { baseRoutes } from "@/api/base-routes";

const x4Api = `${baseRoutes.x4}/api/v1`;

export async function deleteX4Machine(machineId: string): Promise<void> {
	if (!machineId) {
		throw new Error("Machine ID is required for delete");
	}
	await packNetAxios.delete(`${x4Api}/${machineId}`);
}

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.x4}/api/v1/version`);
	return response.data;
}
